import React, { useState, useEffect } from 'react';
import API from '../../../pages/Api'; // 💡 FIX: Removed the invalid 'react-style' line to prevent webpack build crashes
import { FaEdit, FaPlus, FaTimes, FaTrash } from 'react-icons/fa';
import { toast } from 'react-toastify';
import TableContainer from '../../common/Tablecontainer'; // 💡 Ensure paths are linked safely matching your structural rules

const ConclusionMaster = () => {
    const [conclusions, setConclusions] = useState([]);
    const [titles, setTitles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    
    // Action modal operational states references
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [selectedConclusionId, setSelectedConclusionId] = useState(null);
    const [list, setList] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [mobilePage, setMobilePage] = useState(1);
    const [loadingCards, setLoadingCards] = useState(false);

    const pageSize = 10;

    // Controlled form operational parameter states fields
    const [formData, setFormData] = useState({
        tileid: '',
        conclusion: '',
        rangefrom: '0',
        rangeto: '30',
        status: 'A'
    });

    const loadConclusionRecords = async (
        page = 1,
        search = searchQuery
    ) => {

        try {

            setLoadingCards(true);

            const res = await API.get(
                "conclusion-master/",
                {
                    params: {
                        page,
                        search
                    }
                }
            );

            if (res.data.results) {

                setList(res.data.results);
                setTotalCount(res.data.count);

            } else {

                setList(res.data);
                setTotalCount(res.data.length);

            }

        } catch (err) {

            console.error(err);

            setList([]);
            setTotalCount(0);

        } finally {

            setLoadingCards(false);

        }

    };

    const loadDropdownTitleMasters = async () => {
        try {
                const res = await API.get('title-master/');
                
               
                setTitles(res.data.results || res.data || []);
                
            } catch (err) {
                console.error("Error checking dropdown titles elements assets context:", err);
                setTitles([]); 
            }
    };

    useEffect(() => {

        loadDropdownTitleMasters();

    }, []);

    useEffect(() => {

        const timer = setTimeout(() => {

            loadConclusionRecords(
                mobilePage,
                searchQuery
            );

        }, 400);

        return () => clearTimeout(timer);

    }, [mobilePage, searchQuery]);

    const openAddModalWindow = (refreshTable) => {
        setFormData({ tileid: '', conclusion: '', rangefrom: '0', rangeto: '30', status: 'A' });
        setIsEditMode(false);
        setIsModalOpen(true); // 🟢 Opens modal window layout sheet instantly on press
        window.activeTableRefresh = refreshTable;
    };

    const openEditModalWindow = (item,refreshTable) => {
        setFormData({
            tileid: item.tileid,
            conclusion: item.conclusion,
            rangefrom: item.rangefrom,
            rangeto: item.rangeto,
            status: item.status || 'A'
        });
        setSelectedConclusionId(item.conclusionid);
        setIsEditMode(true);
        setIsModalOpen(true); // 🟢 Opens modal window layout sheet instantly on press
        window.activeTableRefresh = refreshTable;
    };

    const handleFormSubmitAction = async (e) => {
        e.preventDefault();
        if (!formData.tileid || !formData.conclusion) {
            toast.warn ("Please complete required input parameters rows configurations.");
            return;
        }

        try {
            if (isEditMode) {
                const res = await API.put(`conclusion-master/${selectedConclusionId}/`, formData);
                if (res.data.status === "Success") toast.success("Conclusion rule configuration updated smoothly.");
            } else {
                const res = await API.post('conclusion-master/', formData);
                if (res.data.status === "Success") toast.success("New conclusion row synchronized inside database ledger.");
            }
            setIsModalOpen(false);

            // Mobile Cards Refresh
            await loadConclusionRecords(
                mobilePage,
                searchQuery
            );

            // Desktop Table Refresh
            if (window.activeTableRefresh) {
                window.activeTableRefresh();
            }
        } catch (err) {
            console.error("Operational crash executing submit payload mapping stack instances:", err);
        }
    };

    const handleRecordDeleteTrigger = async (pk) => {
        if (!window.confirm("Are you completely sure you want to delete this specific database conclusion row record?")) return;
        try {
            const res = await API.delete(`conclusion-master/${pk}/`);
            if (res.data.status === "Success") {
                toast.success("Conclusion removed successfully.");
                await loadConclusionRecords(
                    mobilePage,
                    searchQuery
                );
            }
        } catch (err) {
            console.error("Failure processing delete entity instruction:", err);
        }
    };
    const closeModal = () => {

        setIsModalOpen(false);

        setIsEditMode(false);

        setSelectedConclusionId(null);

        setFormData({
            tileid: '',
            conclusion: '',
            rangefrom: '0',
            rangeto: '30',
            status: 'A'
        });

    };

    // Client-side filtering configuration checks matching wireframe search parameters
    // const filteredConclusions = conclusions.filter(item => 
    //     item.conclusion?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    //     item.title_name?.toLowerCase().includes(searchQuery.toLowerCase())
    // );

    const gridHeaders = ['Title Name', 'Range', 'Conclusion', 'Action'];

    return (
        <div className="p-6 bg-[#F8FAFC] min-h-screen w-full flex flex-col items-center font-sans">
            
            {/* Constrained width layout container block to centralize core elements layout seamlessly */}
            <div className="w-full max-w-8xl mx-auto flex flex-col space-y-4 px-2">
                
                {/* ─── BLOCK 1: PAGE HEADING TITLE ─── */}
                <div className="w-full text-center rounded-lg ">
                    <h2 className="text-center text-2xl sm:text-3xl md:text-4xl font-light text-gray-700 mb-8 tracking-tight">
                           Conclusion Master
                    </h2>
                </div>

                {/* ─── BLOCK 2 & 4: SEARCH BAR & SIZES DROPDOWN (Injected dynamically through your shared TableContainer) ─── */}

                {/* ─── BLOCK 3: SEPARATE ROW CONTAINER FOR ADD BUTTON RIGHT BELOW FILTERS ─── */}
                <div className="w-full px-2 py-2 flex justify-center md:justify-end items-center">
                    <button 
                        type="button"
                        onClick={() =>
                            openAddModalWindow(
                                window.activeTableRefresh
                            )
                        }
                        className="w-full md:w-auto bg-[#032167] text-white px-5 py-2 rounded text-xs font-semibold tracking-wide flex items-center gap-2 hover:bg-blue-950 transition-all border-none cursor-pointer shadow-sm active:scale-95"
                    >
                        <FaPlus size={10} /> Add New
                    </button>
                </div>

                {/* ─── BLOCK 4: CORE RENDER PRESENTATION DATA TABLE ─── */}
                <div className="hidden md:block">
                <TableContainer
                    columns={gridHeaders}
                    apiUrl="conclusion-master/"
                    searchQuery={searchQuery}
                    setSearchQuery={setSearchQuery} 
                    searchPlaceholder="Search conclusions globally across all pages..."
                    renderRow={(item, index, srNo, formatCurrency, refreshTable) => (
                        <tr key={item.conclusionid || index} className="border-b border-gray-200 hover:bg-gray-50 transition-colors h-[40px] text-gray-700 text-xs font-medium bg-white">
                            <td className="p-3 border-r bg-gray-50/50 font-bold text-gray-400 w-[8%] text-center">{srNo}</td>
                            <td className="p-3 border-r text-left pl-5 w-[22%] uppercase font-bold text-[#032167] tracking-wide">{item.title_name || 'N/A'}</td>
                            <td className="p-3 border-r font-semibold text-gray-500 w-[14%] text-center">{item.range_display || `${item.rangefrom} - ${item.rangeto}`}</td>
                            <td className="p-3 border-r text-left pl-5 font-normal text-gray-600 max-w-xl truncate">{item.conclusion}</td>
                            
                            {/* Action columns layout splits matching design parameters with center alignments */}
                            <td className="w-[12%] p-0">
                                <div className="flex items-center justify-center w-full h-[40px]">
                                    <div className="flex-1 flex justify-center items-center h-full border-r border-gray-200">
                                        <button type="button" onClick={() => openEditModalWindow(item, refreshTable)} className="text-[#5c9314] hover:text-green-800 border-none bg-transparent cursor-pointer transition-all flex items-center justify-center w-full h-full" title="Edit Conclusion Rules">
                                            <FaEdit size={18} />
                                        </button>
                                    </div>
                                    <div className="flex-1 flex justify-center items-center h-full">
                                        <button type="button" onClick={() => handleRecordDeleteTrigger(item.conclusionid, refreshTable)} className="text-gray-400 hover:text-red-600 border-none bg-transparent cursor-pointer transition-all flex items-center justify-center w-full h-full" title="Delete Conclusion Entry">
                                            <FaTrash size={16} />
                                        </button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    )}
                />

                </div>
                <div className="md:hidden mt-4">

                <input
                type="text"
                value={searchQuery}
                placeholder="Search Conclusion..."
                onChange={(e)=>{

                setSearchQuery(e.target.value);

                setMobilePage(1);

                }}
                className="w-full border rounded-lg p-3 text-sm outline-none"
                />

                </div>
            <div className="md:hidden space-y-4 mt-4">

                {

                loadingCards

                ?

                <div className="text-center py-10">

                Loading...

                </div>

                :

                list.length===0

                ?

                <div className="text-center py-10">

                No Record Found

                </div>

                :

                list.map((item)=>(

                <div
                key={item.conclusionid}
                className="bg-white rounded-xl shadow border p-4">

                <div className="space-y-3">

                <div>

                <p className="text-xs text-gray-500">

                Title

                </p>

                <p className="font-bold text-[#032167]">

                {item.title_name}

                </p>

                </div>

                <div>

                <p className="text-xs text-gray-500">

                Range

                </p>

                <p className="font-semibold">

                {item.range_display}

                </p>

                </div>

                <div>

                <p className="text-xs text-gray-500">

                Conclusion

                </p>

                <p className="text-sm">

                {item.conclusion}

                </p>

                </div>

                <div className="flex justify-end gap-4 border-t pt-3">

                <button
                onClick={()=>
                openEditModalWindow(
                item,
                window.activeTableRefresh
                )
                }
                className="text-green-600">

                <FaEdit/>

                </button>

                <button
                onClick={()=>
                handleRecordDeleteTrigger(
                item.conclusionid
                )
                }
                className="text-red-600">

                <FaTrash/>

                </button>

                </div>

                </div>

                </div>

                ))

                }

                </div>
                <div className="md:hidden flex justify-between items-center mt-5">

                <button
                disabled={mobilePage===1}
                onClick={()=>setMobilePage(p=>p-1)}
                className="px-4 py-2 border rounded disabled:opacity-40">

                Previous

                </button>

                <span>

                Page {mobilePage} of {Math.max(1,Math.ceil(totalCount/pageSize))}

                </span>

                <button
                disabled={
                mobilePage>=Math.max(
                1,
                Math.ceil(totalCount/pageSize)
                )
                }
                onClick={()=>setMobilePage(p=>p+1)}
                className="px-4 py-2 border rounded disabled:opacity-40">

                Next

                </button>

                </div>


            </div>

            {/* --- Add / Edit PopUp Form Modal Panel Overlay Framework --- */}
            {isModalOpen && (
                <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm overflow-y-auto z-[5000]">
                    <div className="min-h-full flex items-center justify-center p-3 md:p-6">
                    <div className="bg-white w-full max-w-[95vw] sm:max-w-2xl rounded-2xl shadow-2xl overflow-hidden relative border border-slate-100 flex flex-col transform transition-all animate-in zoom-in-95 duration-200">
                        
                        {/* ─── MODAL HEADER ─── */}
                        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100 bg-[#032167]">
                            <h3 className="text-sm font-bold text-white bg-[#032167] uppercase tracking-wider">
                                {isEditMode ? '📝 Modify Conclusion Rule' : '✨ Add New Conclusion Entry'}
                            </h3>
                            <button 
                                type="button" 
                               onClick={closeModal}
                                className="text-slate-400 hover:text-slate-700 border-none bg-transparent text-xl cursor-pointer font-bold flex items-center justify-center p-1 rounded-full hover:bg-slate-100 transition-colors"
                            >
                                <FaTimes size={16} />
                            </button>
                        </div>

                        {/* ─── FORM CONTAINER ─── */}
                        <form onSubmit={handleFormSubmitAction} className="p-3 sm:p-5 md:p-6 space-y-5 text-xs font-bold uppercase text-slate-600 tracking-wide">
                            
                            {/* ROW 1: Two Column Layout for Select Elements */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                                <div className="flex flex-col space-y-2">
                                    <label className="text-slate-700">Category Master Title <span className="text-red-500">*</span></label>
                                    <select 
                                        value={formData.tileid} 
                                        onChange={(e) => setFormData({...formData, tileid: e.target.value})} 
                                        className="p-3 border border-slate-200 rounded-xl outline-none bg-slate-50/50 text-slate-800 normal-case font-semibold focus:border-[#032167] focus:ring-2 focus:ring-blue-100 transition-all cursor-pointer shadow-inner"
                                        required
                                    >
                                        <option value="">-- Choose Title Header --</option>
                                        {Array.isArray(titles) && titles.map(t => (
                                            <option key={t.tileid} value={t.tileid}>{t.titledesc}</option>
                                        ))}
                                    </select>
                                </div>

                                <div className="flex flex-col space-y-2">
                                    <label className="text-slate-700">Active Status Mode</label>
                                    <select 
                                        value={formData.status} 
                                        onChange={(e) => setFormData({...formData, status: e.target.value})} 
                                        className="p-3 border border-slate-200 rounded-xl outline-none bg-slate-50/50 text-slate-800 font-semibold focus:border-[#032167] focus:ring-2 focus:ring-blue-100 transition-all cursor-pointer shadow-inner"
                                    >
                                        <option value="A">🟢 Active Permission State</option>
                                        <option value="I">🔴 Inactive Locked State</option>
                                    </select>
                                </div>
                            </div>

                            {/* ROW 2: Balanced Score Range Selector */}
                            <div className="bg-slate-50/50 p-4 rounded-2xl border border-slate-100 space-y-3">
                                <span className="text-[10px] text-slate-400 block tracking-widest font-bold">Evaluation Score Matrix</span>
                                <div className="grid grid-cols-2 gap-4">
                                    <div className="flex flex-col space-y-1.5">
                                        <label className="text-slate-500 text-[11px]">Range From <span className="text-red-500">*</span></label>
                                        <input 
                                            type="number" 
                                            value={formData.rangefrom} 
                                            onChange={(e) => setFormData({...formData, rangefrom: e.target.value})} 
                                            className="p-2.5 border border-slate-200 rounded-xl outline-none bg-white font-bold text-center text-slate-800 text-sm focus:border-[#032167] focus:ring-2 focus:ring-blue-100 transition-all" 
                                            placeholder="0"
                                            required 
                                        />
                                    </div>
                                    <div className="flex flex-col space-y-1.5">
                                        <label className="text-slate-500 text-[11px]">Range To <span className="text-red-500">*</span></label>
                                        <input 
                                            type="number" 
                                            value={formData.rangeto} 
                                            onChange={(e) => setFormData({...formData, rangeto: e.target.value})} 
                                            className="p-2.5 border border-slate-200 rounded-xl outline-none bg-white font-bold text-center text-slate-800 text-sm focus:border-[#032167] focus:ring-2 focus:ring-blue-100 transition-all" 
                                            placeholder="100"
                                            required 
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* ROW 3: Full Width Narrative Textarea */}
                            <div className="flex flex-col space-y-2">
                                <label className="text-slate-700">Conclusion Narrative Text <span className="text-red-500">*</span></label>
                                <textarea 
                                    rows={4} 
                                    value={formData.conclusion} 
                                    onChange={(e) => setFormData({...formData, conclusion: e.target.value})} 
                                    placeholder="Type conclusion feedback message or evaluation rules here..." 
                                    className="p-3 border border-slate-200 rounded-xl outline-none bg-slate-50/50 font-medium normal-case text-slate-700 text-sm focus:border-[#032167] focus:ring-2 focus:ring-blue-100 transition-all resize-none shadow-inner leading-relaxed" 
                                    required 
                                />
                            </div>

                            {/* ─── MODAL FOOTER ACTIONS ─── */}
                            <div className="flex flex-col-reverse sm:flex-row justify-end gap-3 pt-4 border-t border-slate-100 mt-4">
                                <button 
                                    type="button" 
                                    onClick={closeModal} 
                                    className="w-full sm:w-auto px-5 py-2.5 bg-slate-100 text-slate-600 rounded-xl font-bold uppercase tracking-wider hover:bg-slate-200 transition-colors cursor-pointer border-none"
                                >
                                    Cancel
                                </button>
                                <button 
                                    type="submit" 
                                    className="w-full sm:w-auto px-8 py-2.5 bg-[#032167] text-white rounded-xl font-bold uppercase tracking-wider hover:bg-blue-950 transition-all cursor-pointer border-none shadow-md shadow-blue-900/10 active:scale-[0.98]"
                                >
                                    Save Conclusion
                                    
                                </button>
                            </div>
                        </form>
                    </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ConclusionMaster;